var render = function render(){var _vm=this,_c=_vm._self._c;return _c('html-renderer-old',{staticClass:"html-template-render",attrs:{"template":_vm.theTemplate,"model":_vm.dataModelScope,"schema":_vm.schema.modelSchema || _vm.schema,"value":_vm.value,"app":_vm.schema.modelApp || _vm.$store.state.site.content.app,"params":_vm.$store.state.site.content.params}})
}
var staticRenderFns = []

export { render, staticRenderFns }